module.exports = __webpack_public_path__ + "img/qr-code-stage.bad0f323.png";